<script setup>
import { computed, defineEmits, defineProps, ref } from "vue";
import { validateQnAPassword } from "@/api";
import { useStore } from "vuex";
import useModal from "@/composables/useModal";

const props = defineProps({
  qnaId: Number,
});

const emits = defineEmits(["submit", "close"]);

const store = useStore();
const userId = computed(() => store.getters.userId);

const { alert } = useModal();

const password = ref("");

async function onSubmit() {
  if (!password.value) {
    alert("비밀번호를 입력해주세요.");
    return;
  }

  const res = await validateQnAPassword({
    memberId: userId.value,
    id: props.qnaId,
    password: password.value,
  });

  if (res?.data?.data === "비밀번호가 맞지 않습니다.") {
    emits("submit", false);
  } else {
    emits("submit", {
      success: true,
      content: res.data.data.content,
    });
  }
}
</script>

<template>
  <div class="popup-bg on"></div>
  <div class="popup-cont w01 on" id="popup-goods">
    <div class="popup-header">
      <h3 class="title">비밀번호 확인</h3>
      <button type="button" class="popup-close-btn" @click="$emit('close')">
        닫기
      </button>
    </div>
    <div class="popup-body">
      <div class="popup_write type-03">
        <div class="input_wrap">
          <form @submit.prevent="onSubmit">
            <p class="input_tit">비밀번호를 입력해주세요</p>
            <div class="input_area">
              <input type="password" name="passwordCheck" v-model="password" />
            </div>
            <div class="btn_area">
              <button type="submit" class="btn form02">확인</button>
              <button
                type="button"
                class="btn popup-close"
                @click="$emit('close')"
              >
                취소
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
